import { ExpressOnboardingProvider } from "@/components/express-onboarding/express-onboarding-provider";
import { AppSidebar } from "@/components/app-sidebar";
import { GlobalSearchShell } from "@/components/global-search/global-search-shell";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { Outlet } from "react-router";

export default function RootLayout() {
  return (
    <SidebarProvider>
      <GlobalSearchShell>
        <ExpressOnboardingProvider>
          <AppSidebar />
          <SidebarInset>
            <Outlet />
          </SidebarInset>
        </ExpressOnboardingProvider>
      </GlobalSearchShell>
    </SidebarProvider>
  );
}
